import 'rc-tooltip/assets/bootstrap_white.css';
import React from 'react';
import classes from './MTooltip.module.scss';
import Tooltip from 'rc-tooltip';
import { MTooltipPosition } from './MTooltip.model';


type Props = {
  text: string | JSX.Element;
  position?: MTooltipPosition;
  trigger?: ('hover' | 'click' | 'focus' | 'contextMenu')[];  
};

const MTooltipView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const overlay = <span>{props.text}</span>;

  return (
    <Tooltip 
      id="general-tooltip" 
      placement={props.position} 
      classNames={{root: classes['overlay']}}
      trigger={props.trigger?.length ? props.trigger : ['hover']}
      showArrow={false}
      overlay={overlay}
    >
      {React.isValidElement(props.children) ? props.children : <span>{props.children}</span>}
    </Tooltip>
  );
  //   <div className={classNames(classes['tooltip'], props.elementClassName)}>
  //     {props.children}

  //     {props.text ? (
  //       <span
  //         className={classNames(
  //           classes['tooltiptext'],
  //           classes[`tooltiptext--${props.position}`],
  //           { [classes.invert]: props.invertIndicatorPosition },
  //           props.className,
  //         )}
  //         style={{
  //           ...(props.offsetX && { marginLeft: props.offsetX }),
  //           ...(props.offsetY && { marginTop: props.offsetY }),
  //         }}
  //       >
  //         {props.text}
  //       </span>
  //     ) : null}
  //   </div>
  // );
};

MTooltipView.displayName = 'MTooltipView';
MTooltipView.defaultProps = {
  position: MTooltipPosition.Top,
};

export default MTooltipView;
